import { SEMRUSH_PROD_APP_URL, SEMRUSH_TEST_APP_URL } from '@anm/constants/services';
import * as semrush from '@anm/helpers/semrush';
import { useEffect } from 'react';
import { User } from 'user';

const useRedirectSemrushUser = (user: User | null, isProd: boolean) => {
  const isSemrushIframe = semrush.isSemrushIframe();
  const isSemrushUser = user?.meta.entry === 'SEMRUSH';
  const semrushAppUrl = isProd ? SEMRUSH_PROD_APP_URL : SEMRUSH_TEST_APP_URL;

  const canRedirectToSemrushApp = !isSemrushIframe && isSemrushUser;

  useEffect(() => {
    canRedirectToSemrushApp && window.open(semrushAppUrl, '_self');
  }, [canRedirectToSemrushApp]);
};

export default useRedirectSemrushUser;
